/* ══════════════════════════════════════════════════════════════════════════
   PDP — reads ?shape=<handle> across all 19 SKUs (defaults to the top
   bestseller). Gallery renders every shippable photo of the SKU, hero first.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var SQ = window.SQ;

  function qShape() {
    /* On Shopify the template injects the real product handle; the static
       build reads ?shape=. Same catalogue key either way. */
    var h = (typeof window !== 'undefined' && window.SQ_PDP_HANDLE) || null;
    if (h && SQ.CATALOGUE[h]) return h;
    var v = new URLSearchParams(location.search).get('shape');
    return SQ.CATALOGUE[v] ? v : 'doughnut';
  }

  var shape = qShape();
  var P = SQ.CATALOGUE[shape];
  var state = { frame: 0, qty: 1, squishes: 0, stickyOn: false };

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };
  var setAll = function (sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); };

  /* ───────────────────────────  static fill  ───────────────────────────── */
  document.title = P.name + ' — Squishit';
  setAll('[data-p-name]', P.name);
  setAll('[data-p-no]', P.no);
  setAll('[data-p-rating]', P.rating);
  setAll('[data-p-count]', P.count);
  $('[data-p-headline]').textContent = P.benefit;
  $('[data-p-desc]').textContent = P.desc;

  /* Specs: no fabricated weights. Weight/size cells show only when the
     client supplies real numbers in the catalogue (w / s fields). */
  ['w', 's'].forEach(function (k) {
    var el = $('[data-spec-' + k + ']');
    if (!el) return;
    if (P[k]) el.textContent = P[k];
    else el.parentElement.style.display = 'none';
  });

  var ogTitle = document.createElement('meta');
  ogTitle.setAttribute('property', 'og:title');
  ogTitle.content = P.name + ' — Squishit';
  document.head.appendChild(ogTitle);

  /* ────────────────────────────  gallery  ──────────────────────────────── */
  /* ═══════════════════  gallery + colour picker  ════════════════════════
     Every image stays on the product in Shopify. The FRONT END decides which
     ones to show: pick a colour and the rail rebuilds with just that colour's
     shots, indicator and counter included. Nothing is deleted anywhere, so a
     colour with no matched images falls back to the full set rather than
     leaving someone staring at an empty frame. */
  var COLOURS = SQ.coloursOf ? SQ.coloursOf(shape) : [];
  var hasColours = COLOURS.length > 1;
  var current = hasColours ? COLOURS[0] : null;
  var shots = [];

  function shotsFor(colour) {
    if (SQ.imagesFor) {
      var live = SQ.imagesFor(shape, colour);
      if (live && live.length) return live;
    }
    var out = [];
    for (var i = 1; i <= SQ.photoCount(shape); i++) out.push(SQ.photo(shape, i));
    return out;
  }

  var stage  = $('[data-stage]');
  var segNav = $('[data-seg-nav]');
  var shotCount = $('[data-shot-count]');
  var shotPrev  = $('[data-shot-prev]');
  var shotNext  = $('[data-shot-next]');

  function renderGallery(keepIndex) {
    shots = shotsFor(current && current.name);
    stage.innerHTML = shots.map(function (src, idx) {
      var alt = P.name + (current ? ' — ' + current.name : '') + ' photo ' + (idx + 1);
      return '<div class="pdp-frame" data-frame="' + idx + '">' +
        '<img src="' + src + '" alt="' + alt + '"' +
        (idx === 0 ? ' fetchpriority="high" decoding="async"' : ' loading="lazy"') +
        ' style="width:100%;height:100%;object-fit:cover;display:block"></div>';
    }).join('') + (P.badge ? '<span class="pdp-badge">' + P.badge + '</span>' : '');

    if (segNav) {
      segNav.innerHTML = shots.map(function (_, i) {
        return '<span role="tab" data-go="' + i + '" aria-label="Photo ' + (i + 1) + '"></span>';
      }).join('');
    }
    /* a shorter set after a colour change must not leave us out of range */
    var i = Math.min(keepIndex || 0, shots.length - 1);
    stage.scrollLeft = i * stage.clientWidth;
    paintShots(i);
  }

  function currentSlide() {
    return stage.clientWidth ? Math.round(stage.scrollLeft / stage.clientWidth) : 0;
  }
  function paintShots(i) {
    if (segNav) {
      segNav.querySelectorAll('[data-go]').forEach(function (el, n) {
        el.classList.toggle('is-on', n <= i);
        el.classList.toggle('is-here', n === i);
      });
    }
    if (shotCount) shotCount.textContent = (i + 1) + ' / ' + shots.length;
    if (shotPrev) shotPrev.disabled = i <= 0;
    if (shotNext) shotNext.disabled = i >= shots.length - 1;
  }
  function goShot(i) {
    i = Math.max(0, Math.min(shots.length - 1, i));
    stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
  }

  stage.addEventListener('scroll', function () { paintShots(currentSlide()); }, { passive: true });
  window.addEventListener('resize', function () { paintShots(currentSlide()); });
  if (segNav) segNav.addEventListener('click', function (e) {
    var t = e.target.closest('[data-go]'); if (t) goShot(+t.getAttribute('data-go'));
  });
  if (shotPrev) shotPrev.addEventListener('click', function () { goShot(currentSlide() - 1); });
  if (shotNext) shotNext.addEventListener('click', function () { goShot(currentSlide() + 1); });
  stage.tabIndex = 0;
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); goShot(currentSlide() + 1); }
    if (e.key === 'ArrowLeft')  { e.preventDefault(); goShot(currentSlide() - 1); }
  });

  /* ── the picker ─────────────────────────────────────────────────────────
     Only rendered when a shape genuinely has more than one colourway, so the
     four single-colour SKUs never show a pointless one-option row. */
  var pickHost = $('[data-colour-pick]');
  function renderPicker() {
    if (!pickHost || !hasColours) return;
    pickHost.innerHTML =
      '<div class="cpick-head"><span class="cpick-lbl">Colour</span>' +
      '<span class="cpick-now" data-colour-now>' + current.name + '</span></div>' +
      '<div class="cpick-row" role="radiogroup" aria-label="Colour">' +
      COLOURS.map(function (c, i) {
        /* a colour chip, not a photo thumbnail. Two stops so a two-tone
           shape reads honestly; one flat fill when both stops match. */
        var hx = c.hex || ['#d7d3d3', '#d7d3d3'];
        var fill = (hx[0] === hx[1])
          ? hx[0]
          : 'linear-gradient(135deg, ' + hx[0] + ' 0 50%, ' + hx[1] + ' 50% 100%)';
        return '<button class="cpick" role="radio" data-colour="' + c.name + '"' +
          ' aria-checked="' + (i === 0) + '"' + (c.available ? '' : ' data-oos') +
          ' aria-label="' + c.name + '" title="' + c.name + '"' +
          ' style="background:' + fill + '"></button>';
      }).join('') + '</div>';
  }
  if (pickHost && hasColours) {
    pickHost.addEventListener('click', function (e) {
      var b = e.target.closest('[data-colour]'); if (!b) return;
      var name = b.getAttribute('data-colour');
      if (current && name === current.name) return;
      current = COLOURS.filter(function (c) { return c.name === name; })[0];
      pickHost.querySelectorAll('[data-colour]').forEach(function (x) {
        x.setAttribute('aria-checked', String(x === b));
      });
      var now = $('[data-colour-now]'); if (now) now.textContent = current.name;
      renderGallery(0);
      var v = SQ.variantFor(shape, current.name);
      if (v) { state.variantId = v.id; if (v.price) state.price = v.price; }
      renderQty();
    });
  }

  renderPicker();
  renderGallery(0);
  var frames = shots;

  /* Product schema (framework SEO layer) — real values from the catalogue. */
  var ld = document.createElement('script');
  ld.type = 'application/ld+json';
  ld.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: P.name,
    sku: 'SQ-' + P.no,
    description: P.desc,
    image: location.origin + '/' + SQ.photo(shape, 1),
    brand: { '@type': 'Brand', name: 'Squishit' },
    offers: {
      '@type': 'Offer',
      price: String(SQ.UNIT),
      priceCurrency: 'INR',
      availability: 'https://schema.org/InStock'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: P.rating,
      reviewCount: P.count
    }
  });
  document.head.appendChild(ld);

  /* ───────────────────  browse axes, as links not labels  ─────────────────
     Q2 of the buyer's five: "is this the right one for me". Shape and feel
     are the only two properties readable straight off the photograph, so
     they're the only two published — no invented firmness rating. */
  $('[data-axes]').innerHTML =
    '<a class="axis-chip" href="' + SQ.collectionUrl('cat=' + P.cat) + '">' + SQ.CATS[P.cat] + '</a>' +
    '<a class="axis-chip" href="' + SQ.collectionUrl('feel=' + P.feel) + '">' + SQ.FEELS[P.feel] + '</a>' +
    '<span class="axis-chip axis-chip--flat">No. ' + P.no + ' of 19</span>';

  /* ──────────────────────────  qty + ATC  ──────────────────────────────── */
  /* The delivered total, recomputed with the stepper. Shipping is the cost
     that ambushes people at the payment step, so it is stated up front and
     the free-shipping line names exactly what closes the gap. */
  function renderCost() {
    var goods = SQ.UNIT * state.qty;
    var ship = goods >= SQ.SHIP_FREE_OVER ? 0 : SQ.SHIP_FLAT;
    var el = $('[data-cost-line]');
    if (!el) return;

    if (ship === 0) {
      el.innerHTML = '<b>' + SQ.fmt(goods) + ' delivered.</b> Shipping is on us over ' +
        SQ.fmt(SQ.SHIP_FREE_OVER) + '.';
    } else {
      var gap = SQ.SHIP_FREE_OVER - goods;
      var more = Math.ceil(gap / SQ.UNIT);
      el.innerHTML = '<b>' + SQ.fmt(goods + ship) + ' delivered</b> — ' + SQ.fmt(goods) +
        ' plus ' + SQ.fmt(ship) + ' shipping. ' +
        (more > 0 ? 'Add ' + more + ' more and shipping is free.' : '');
    }
  }

  /* A date beats a duration everywhere. Same window the pincode check uses,
     so the two can never contradict each other on the same screen. */
  var etaEl = $('[data-eta]');
  if (etaEl) etaEl.textContent = 'Order today, it reaches you by ' + SQ.deliveryDate(4) + '.';
  var satcEta = $('[data-satc-eta]');
  if (satcEta) satcEta.textContent = 'By ' + SQ.deliveryDate(4);

  function renderQty() {
    $('[data-qty]').textContent = state.qty;
    $('[data-atc-price]').textContent = SQ.fmt(SQ.UNIT * state.qty);
    renderCost();
  }

  $('[data-q-inc]').addEventListener('click', function () { state.qty = Math.min(9, state.qty + 1); renderQty(); });
  $('[data-q-dec]').addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); renderQty(); });

  $$('[data-atc]').forEach(function (b) {
    b.addEventListener('click', function () { SQ.addItem(shape, state.qty, true); });
  });

  /* ────────────────────────  pincode estimator  ────────────────────────── */
  var pinInput = $('[data-pin]');
  var pinMsg = $('[data-pin-msg]');

  pinInput.addEventListener('input', function () {
    pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6);
    pinMsg.hidden = true;
  });
  pinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); checkPin(); } });
  $('[data-pin-check]').addEventListener('click', checkPin);

  function checkPin() {
    var v = pinInput.value;
    pinMsg.hidden = false;

    /* Format check only — real serviceability comes from a courier API on build. */
    if (!/^[1-9][0-9]{5}$/.test(v)) {
      pinMsg.textContent = 'Enter a valid 6-digit pincode.';
      pinMsg.classList.add('is-err');
      return;
    }
    pinMsg.textContent = '✓ We deliver here. Order today and it reaches you by ' +
      SQ.deliveryDate(4) + '. Cash on delivery works.';
    pinMsg.classList.remove('is-err');
  }

  /* ──────────────────────────  squish test  ────────────────────────────
     Counts every press, persists across visits, unlocks RESTLESS5 at 10.  */
  var SQ_KEY = 'sq-squishes';
  try { state.squishes = parseInt(localStorage.getItem(SQ_KEY) || '0', 10) || 0; } catch (e) {}

  var segsEl = $('[data-segs]');
  var countEl = $('[data-sq-n]');
  var couponSlot = $('[data-coupon-slot]');

  var segMarkup = '';
  for (var si = 0; si < 10; si++) segMarkup += '<span class="seg" data-seg="' + si + '"></span>';
  segsEl.insertAdjacentHTML('afterbegin', segMarkup);

  function renderSquish() {
    var n = Math.min(10, state.squishes);
    $$('[data-seg]').forEach(function (s, i) { s.classList.toggle('is-on', i < state.squishes); });
    countEl.textContent = n;

    if (state.squishes >= 10) {
      if (!couponSlot.querySelector('.coupon')) {
        couponSlot.innerHTML = '<div class="coupon">' +
          '<span class="coupon-h">Restless certified — 5% off unlocked</span>' +
          '<div class="coupon-row"><span class="coupon-code">RESTLESS5</span>' +
          '<button class="coupon-copy" data-copy>Copy code</button></div>' +
          '<span class="coupon-fine">Paste it at checkout. Works once per customer.</span>' +
        '</div>';
      }
    } else {
      couponSlot.innerHTML = '<span class="sq-hint">' + (
        state.squishes === 0 ? 'Go on. It wants to be pressed.'
          : state.squishes < 5 ? 'Keep going — ' + (10 - state.squishes) + ' to go.'
            : 'Almost there. ' + (10 - state.squishes) + ' more.'
      ) + '</span>';
    }
  }

  /* pointerdown, not click — rapid mashing has to count every press */
  $('[data-sq-pad]').addEventListener('pointerdown', function () {
    state.squishes = Math.min(99, state.squishes + 1);
    try { localStorage.setItem(SQ_KEY, String(state.squishes)); } catch (e) {}
    renderSquish();
  });

  couponSlot.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var done = function () {
      b.textContent = 'Copied ✓';
      setTimeout(function () { b.textContent = 'Copy code'; }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText('RESTLESS5').then(done, done);
    } else done();
  });

  /* ────────────────────────────  pairs with  ───────────────────────────── */
  var others = SQ.ALL.filter(function (id) { return id !== shape; })
    .sort(function (a, b) { return SQ.CATALOGUE[b].pop - SQ.CATALOGUE[a].pop; })
    .slice(0, 2)
    .map(function (id) { return SQ.CATALOGUE[id]; });

  $('[data-pairs]').innerHTML = others.map(function (p) {
    return '<div class="pair-card">' +
      '<div class="pcard-bar" style="background:' + p.bar + '"></div>' +
      '<div class="pair-body">' +
        '<img class="dr-thumb" src="' + SQ.photo(p.id, 1) + '" alt="' + p.name + '" width="44" height="44" loading="lazy">' +
        '<div style="flex:1">' +
          '<a class="pcard-title" href="' + SQ.urlOf(p.id) + '"><strong>' + p.name + '</strong></a>' +
          '<span class="pair-blurb">' + p.benefit + ' · ★ ' + p.rating + '</span>' +
        '</div>' +
        '<div class="pair-row">' +
          '<span class="pcard-price"><strong>' + SQ.fmt(SQ.UNIT) + '</strong></span>' +
          '<button class="kc kc--light kc--sm" data-pair-add="' + p.id + '">Add</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }).join('') +
  '<div class="pair-set">' +
    '<span class="pair-set-kick">Complete the set</span>' +
    '<strong>Add ' + others.map(function (o) { return o.name.replace('The ', 'the '); }).join(' + ') + '.</strong>' +
    '<span class="pair-set-sub">Any three shapes in one cart come to ₹2,199, shipping included.</span>' +
    '<button class="kc kc--accent kc--on-ink" data-add-pair>Add both · ' + SQ.fmt(1598) + '</button>' +
  '</div>';

  $('[data-pairs]').addEventListener('click', function (e) {
    var one = e.target.closest('[data-pair-add]');
    if (one) return SQ.addItem(one.getAttribute('data-pair-add'), 1, true);
    if (e.target.closest('[data-add-pair]')) {
      others.forEach(function (p, i, arr) {
        SQ.addItem(p.id, 1, i === arr.length - 1);
      });
    }
  });

  /* ───────────────────────────  sticky ATC  ────────────────────────────── */
  var buy = $('[data-buy]');
  var satc = $('[data-satc]');

  function onScroll() {
    var on = buy.getBoundingClientRect().bottom < 0 || (window.innerWidth <= 640 && window.scrollY > 300);
    if (on === state.stickyOn) return;
    state.stickyOn = on;
    satc.classList.toggle('is-on', on);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ──────────────────────────────  boot  ───────────────────────────────── */
  renderQty();
  renderSquish();
  onScroll();
})();
